import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Feedback } from './feedbackTypes';

type FeedbackTableProps = {
  feedback: Feedback[];
};

/**
 * FeedbackTable
 * @param props FeedbackTableProps
 */
export const FeedbackTable = (props: FeedbackTableProps) => {
  const [rows, setRows] = useState<Feedback[]>([]);

  useEffect(() => {
    if (localStorage.getItem('theme') === 'devhub-dark') {
      import('primereact/resources/themes/md-dark-indigo/theme.css');
    } else {
      import('primereact/resources/themes/md-light-indigo/theme.css');
    }
  }, []);

  useEffect(() => {
    setRows(
      props.feedback.map(f => ({
        ...f,
        id: crypto.getRandomValues(new Uint32Array(1))[0],
      })),
    );
  }, [props.feedback]);

  const renderTimestamp = (rowData: Feedback) => {
    return <span>{new Date(rowData.timestamp).toLocaleString('en-US')}</span>;
  };

  const renderLogin = (rowData: Feedback) => {
    return <span>{rowData.login || ''}</span>;
  };

  return (
    <DataTable
      value={rows}
      paginator
      rows={5}
      rowsPerPageOptions={[5, 10, 20]}
      dataKey="id"
    >
      <Column
        field="timestamp"
        header="Created Date"
        body={renderTimestamp}
        style={{ width: '200px' }}
        sortable
      />
      <Column field="url" header="URL" style={{ width: '450px' }} />
      <Column
        field="rating"
        header="Rating"
        style={{ width: '120px' }}
        sortable
      />
      <Column
        field="login"
        header="User"
        body={renderLogin}
        style={{ width: '200px' }}
        sortable
      />
      <Column field="message" header="Message" />
    </DataTable>
  );
};
